/**
 * Safety net for stranded teleported overlays (TOF-617).
 *
 * On the schedule board, Vue's `<Teleport to="body">` teardown intermittently
 * fails to remove the appointment drawer's wrapper from <body> when the drawer
 * closes, leaving it stranded on screen (the "click-away / close does nothing"
 * symptom). Callers capture the wrapper node before unmount and, after Vue's
 * teardown flush, pass it here.
 *
 * `.remove()` is a no-op on an already-detached node, and the `isConnected`
 * guard means we only ever act when Vue actually left the node behind — so this
 * never races or double-frees Vue's own successful removal.
 *
 * @returns true if a stranded node was removed, false otherwise.
 */
export function removeStrandedNode(node: Element | null | undefined): boolean {
  if (node && node.isConnected) {
    node.remove();
    return true;
  }
  return false;
}
